<template>
  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading"/>
    <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
      <vs-card>
        <h3 class="card-title">1-Documento</h3>
        <hr class="custom-hr"/>
        <vs-row class="mt-4">
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Código único"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="dianInfo.code"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                type="text"
                label="Número Proveedor"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="dianInfo.supplierCode"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Tipo documento"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="dianInfo.documentType"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Estado"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="dianInfo.statusText"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Fecha DIAN"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="dianInfo.date"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Intentos"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="dianInfo.attempt"
            />
          </vs-col>
          <vs-col vs-lg="12" vs-xs="12">
            <vs-input
                label="Cufe"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="dianInfo.cufe"
            />
          </vs-col>
        </vs-row>
      </vs-card>
      <vs-card v-if="sendInfo">
        <h3 class="card-title">3-Información enviada</h3>
        <hr class="custom-hr"/>
        <vs-row class="mt-4">

          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Fecha"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.date"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                type="text"
                label="Enviar correo"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.sendEmail"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Enviar a DIAN"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.sendDian"
            />
          </vs-col>
        </vs-row>

        <hr class="custom-hr"/>
        <h5 class="card-title">Cliente</h5>
        <vs-row class="mt-4">
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Tipo identificación"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.idType"
            />
          </vs-col>

          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Identificación"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.idCard"
            />
          </vs-col>

          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Nombre"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.name+ ' '+ sendInfo.surname"
            />
          </vs-col>

          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Dirección"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.address"/>
          </vs-col>

          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Teléfono"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.phone"/>
          </vs-col>

          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Código ciudad"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.zipcode"
            />
          </vs-col>
        </vs-row>

        <hr class="custom-hr"/>
        <h5 class="card-title">Contacto</h5>
        <vs-row class="mt-4">
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Nombre"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.name"
            />
          </vs-col>

          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Apellidos"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.surname"/>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Correo"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="sendInfo.email"/>
          </vs-col>

        </vs-row>


        <hr class="custom-hr"/>
        <h5 class="card-title">Conceptos</h5>
        <vs-row class="mt-4">
          <div class="table-responsive">
            <vs-table id="contact-table" ref="table"
                      stripe
                      noDataText="No hay información"
                      :hoverFlat="true"
                      :data="sendInfo.items" class="text-nowrap">
              <template slot="thead">
                <vs-th>Código</vs-th>
                <vs-th>Precio</vs-th>
                <vs-th>Impuesto</vs-th>

              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="idx" v-for="(tr, idx) in data">
                  <vs-td :data="tr.concept">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-shopping mr-2 display-8"></i>
                      <span>{{ tr.concept }}</span>
                    </div>
                  </vs-td>
                  <vs-td :data="tr.total">
                    <div class="d-flex no-block ">
                      {{ tr.subtotal }}
                    </div>
                  </vs-td>
                  <vs-td :data="tr.taxInfo">
                    <div class="d-flex align-items-center">
                      {{ tr.tax }}
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-row>

        <hr class="custom-hr"/>
        <h5 class="card-title">Pago</h5>
        <vs-row class="mt-4">
          <div class="table-responsive">
            <vs-table id="contact-table" ref="table"
                      stripe
                      noDataText="No hay información"
                      :hoverFlat="true"
                      :data="sendInfo.paymentInfoList" class="text-nowrap">
              <template slot="thead">
                <vs-th>Medio de pago</vs-th>
                <vs-th>Valor</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="idx" v-for="(tr, idx) in data">
                  <vs-td :data="idx">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-credit-card mr-2 display-8"></i>
                      <span>{{ tr.title }}</span>
                    </div>
                  </vs-td>
                  <vs-td :data="tr.value">
                    <div class="d-flex no-block ">
                      {{ tr.value }}
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-row>

      </vs-card>
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
      <vs-card>
        <h3 class="card-title">2-Documento equivalente</h3>
        <hr class="custom-hr"/>
        <vs-row class="mt-4">
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Número"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="equivalent.number"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Fecha"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="equivalent.date"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Subtotal"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="equivalent.subtotal"
            />
          </vs-col>

          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Impuesto"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="equivalent.tax"
            />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input
                label="Total"
                class="mt-2 w-100"
                readonly="readonly"
                v-model="equivalent.total"
            />
          </vs-col>
        </vs-row>
        <vs-row class="mt-4">
          <div class="table-responsive">
            <vs-table id="contact-table"
                      ref="table"
                      stripe
                      noDataText="No hay información"
                      :hoverFlat="true"
                      :data="equivalent.items" class="text-nowrap">
              <template slot="thead">
                <vs-th>Concepto</vs-th>
                <vs-th>Subtotal</vs-th>
                <vs-th>Impuesto</vs-th>
                <vs-th>Total</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="idx" v-for="(tr, idx) in data">
                  <vs-td :data="tr.concept">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-shopping mr-2 display-8"></i>
                      <span>{{ tr.concept }}</span>
                    </div>
                  </vs-td>
                  <vs-td :data="tr.subtotal">
                    <div class="d-flex no-block ">
                      {{ tr.subtotal }}
                    </div>
                  </vs-td>
                  <vs-td :data="tr.tax">
                    <div class="d-flex align-items-center">
                      {{ tr.tax }}
                    </div>
                  </vs-td>

                  <vs-td :data="tr.total">
                    <div class="d-flex align-items-center">
                      {{ tr.total }}
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-row>
      </vs-card>
      <vs-card>
        <h3 class="card-title">4-Respuesta</h3>
        <hr class="custom-hr"/>
        <vs-row class="mt-0">
          <vs-col vs-lg="12" vs-xs="12">
            <vs-alert v-if="messages" :color="processColor(dianInfo.status)"
                      title="Resultado de los intentos"
                      active="true"
                      class="mb-1">
              <p v-if="messages"
                 v-for="message in messages"
                 class="mb-3 text-wrap">
                {{ message }}
              </p>
            </vs-alert>
          </vs-col>
        </vs-row>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import parkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";


export default {
  name: "ElectronicDetail",
  props: ['documentId'],

  data() {
    return {
      isLoading: false,
      dianInfo: {
        code: null,
        supplierCode: null,
        documentType: null,
        status: null,
        statusText: null,
        date: null,
        attempt: null,
        cufe: null
      },
      equivalent: {
        number: null,
        date: null,
        subtotal: null,
        tax: null,
        total: null,
        items: [
          {
            concept: null,
            subtotal: null,
            tax: null,
            total: null
          },
        ]
      },
      sendInfo: {
        idType: null,
        idCard: null,
        name: '',
        surname: '',
        address: null,
        phone: null,
        email: null,
        date: null,
        sendEmail: null,
        sendDian: null,
        zipcode: null,
        items: [],
        paymentInfoList: []
      },
      messages: null
    };
  },
  mounted() {
    if (!this.documentId) {
      this.$router.push("/view/overview-report/reports/concept-invoice");
      return;
    }
    this.isLoading = true;
    parkingReportsEndpoints.previewElectronicInvoice(this.documentId)
        .then(data => {
              if (data.code < 0) {
                this.$router.push("/view/overview-report/reports/concept-invoice");
                this.isLoading = false;
                return;
              }
              if (data.code === 0) {
                this.$router.push("/view/overview-report/reports/concept-invoice");
                this.isLoading = false;
                return;
              }
              const dataJson = JSON.parse(data.info);
              if (dataJson.dianInfo) this.processDianInfo(dataJson.dianInfo)
              if (dataJson.equivalent) this.equivalent = dataJson.equivalent
              this.processSendInfo(dataJson.sendInfo)
              if (dataJson.messages) this.messages = dataJson.messages
            }
        ).finally(() => this.isLoading = false);
  }
  ,
  methods: {
    processColor(status) {
      return status === 'DRAFT' || status === 'PENDING' || status === 'ACCEPTED'
          ? 'primary'
          : 'danger'
    }
    ,
    processStatus(status) {
      switch (status) {
        case 'DRAFT':
        case 'PENDING':
          return 'Pendiente';
        case 'ACCEPTED':
          return 'Enviado';
        case 'REJECTED':
          return 'Rechazado';
        case 'INCOMPLETE':
          return 'Incompleto';
        case 'ERROR':
          return 'Error';
      }
    }
    ,
    processDianInfo(dianInfo) {
      dianInfo.statusText = this.processStatus(dianInfo.status)
      dianInfo.documentType = 'Factura'
      this.dianInfo = dianInfo
    }
    ,
    processSendInfo(sendInfo) {
      if (!sendInfo) {
        this.sendInfo = null
        return
      }
      sendInfo.sendDian = sendInfo.sendDian ? 'Si' : 'No'
      sendInfo.sendEmail = sendInfo.sendEmail ? 'Si' : 'No'
      this.sendInfo = sendInfo
    }
  }
}
;
</script>